// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.social-media-demo-container {
  max-width: 1200px;
  margin: 3rem auto;
  margin-top: 0;
  padding: 0 1.5rem;
}

.social-media-demo-header {
  text-align: center;
  margin-bottom: 2rem;
}

.social-media-demo-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.5rem;
}

.social-media-demo-description {
  font-size: 1.1rem;
  color: #666;
  margin-bottom: 2rem;
}

.social-media-demo-toggle {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;
}

.toggle-button {
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: 30px;
  background-color: #f0f0f0;
  color: #555;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.toggle-button:hover {
  background-color: #e8e8e8;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
}

.toggle-button.active {
  background: linear-gradient(90deg, #4776E6, #8E54E9);
  color: white;
  box-shadow: 0 4px 15px rgba(71, 118, 230, 0.3);
}

.social-media-demo-content {
  position: relative;
  min-height: 400px;
}

.social-media-demo-version {
  animation: fadeIn 0.5s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Responsive design */
@media (max-width: 768px) {
  .social-media-demo-container {
    margin: 2rem auto;
  }
  
  .social-media-demo-title {
    font-size: 2rem;
  }
  
  .social-media-demo-toggle {
    flex-direction: column;
    align-items: center;
    gap: 0.8rem;
  }
  
  .toggle-button {
    width: 100%;
    max-width: 250px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SocialMedia/SocialMediaDemo.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF","sourcesContent":[".social-media-demo-container {\n  max-width: 1200px;\n  margin: 3rem auto;\n  margin-top: 0;\n  padding: 0 1.5rem;\n}\n\n.social-media-demo-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.social-media-demo-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 0.5rem;\n}\n\n.social-media-demo-description {\n  font-size: 1.1rem;\n  color: #666;\n  margin-bottom: 2rem;\n}\n\n.social-media-demo-toggle {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.toggle-button {\n  padding: 0.8rem 1.5rem;\n  border: none;\n  border-radius: 30px;\n  background-color: #f0f0f0;\n  color: #555;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n}\n\n.toggle-button:hover {\n  background-color: #e8e8e8;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\n}\n\n.toggle-button.active {\n  background: linear-gradient(90deg, #4776E6, #8E54E9);\n  color: white;\n  box-shadow: 0 4px 15px rgba(71, 118, 230, 0.3);\n}\n\n.social-media-demo-content {\n  position: relative;\n  min-height: 400px;\n}\n\n.social-media-demo-version {\n  animation: fadeIn 0.5s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .social-media-demo-container {\n    margin: 2rem auto;\n  }\n  \n  .social-media-demo-title {\n    font-size: 2rem;\n  }\n  \n  .social-media-demo-toggle {\n    flex-direction: column;\n    align-items: center;\n    gap: 0.8rem;\n  }\n  \n  .toggle-button {\n    width: 100%;\n    max-width: 250px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
